import styled, { css } from "styled-components";

const StyledSVGPath = styled.svg`
  path {
    fill: ${({ disabled }) => (disabled ? "var(--du-color-icon-disabled)" : "var(--du-color-icon)")};
    transition: fill 0.2s ease;
  }

  path[fill] {
    fill: ${({ disabled }) => (disabled ? "var(--du-color-icon-disabled)" : "currentColor")};
  }
`;

const SVGContainer = styled.div`
  display: inline-block;

  ${({ noHover, disabled }) =>
    !noHover &&
    !disabled &&
    css`
      &:not(:disabled):hover ${StyledSVGPath} path {
        fill: var(--du-color-hover);
        stroke: var(--du-color-hover);
        stroke-width: 1;
      }
    `}

  /* Ensure disabled state prevents hover effects */
  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      opacity: 0.6;
    `}
`;

const SVGContainerPath = ({ disabled = false, noHover = false, ...rest }) => (
  <SVGContainer disabled={disabled} noHover={noHover}>
    <StyledSVGPath disabled={disabled} {...rest} />
  </SVGContainer>
);

export default SVGContainerPath;
